import { render, staticRenderFns } from "./empty-learning.vue?vue&type=template&id=1383f631&scoped=true"
import script from "./empty-learning.vue?vue&type=script&lang=js"
export * from "./empty-learning.vue?vue&type=script&lang=js"
import style0 from "./empty-learning.vue?vue&type=style&index=0&id=1383f631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1383f631",
  null
  
)

export default component.exports